import { PspContext } from "@/config/contexts";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

export function useNotificationsMobileTopBar() {
  const { lang } = useContext(PspContext);
  const navigate = useNavigate();
  function onBack() {
    navigate(-1);
  }

  return { onBack, lang };
}
